"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetSnapshotAsAThumbnail = void 0;
var _react = require("react");
var _alloyReactNotification = require("@adsk/alloy-react-notification");
var _issueSnapshots = require("../../../../state/redux/ducks/issueSnapshots");
var _hooks = require("../../../../state/redux/hooks");
var _featureFlags = require("../../../../utils/featureFlags");
var _useSdk = require("../../../../state/sdk/useSdk");
var _useTranslations = require("../../../../utils/i18n/useTranslations");
var _issueActionsTracking = require("../../../../utils/analytics/issueActionsTracking");
var _issuesCollection = require("../../../../state/redux/ducks/issuesCollection");
var _useSnapshotAbortController = require("./useSnapshotAbortController");
var _issueLinkedDocumentsUtils = require("../../../../utils/data/issueLinkedDocumentsUtils");
const useSetSnapshotAsAThumbnail = () => {
  const dispatch = (0, _hooks.useDispatch)();
  const {
    showNotification
  } = (0, _alloyReactNotification.useNotifications)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: displayThumbnailField
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.DisplayIssueThumbnailField);
  const {
    throwIfAborted,
    isAbortError
  } = (0, _useSnapshotAbortController.useSnapshotAbortController)();
  const sdk = (0, _useSdk.useSdk)();
  return (0, _react.useCallback)(async _ref => {
    let {
      issue,
      storageUrn,
      hasMarkups,
      trigger,
      flowId,
      onSuccess,
      handleFailureNotification
    } = _ref;
    if (!displayThumbnailField || !storageUrn || !(0, _issueLinkedDocumentsUtils.is3dIssue)(issue)) {
      return;
    }
    try {
      // Avoid creating the snapshot if the flow was aborted
      throwIfAborted(flowId);
      const linkPromise = sdk.Oss.getDownloadLink(storageUrn);
      const issueSnapshotPromise = sdk.IssueSnapshots.create(issue.id, storageUrn, hasMarkups);
      const [downloadLink] = await Promise.all([linkPromise, issueSnapshotPromise]);

      // Avoid updating the state if the flow was aborted
      throwIfAborted(flowId);
      dispatch((0, _issueSnapshots.issueSnapshotUploadSuccess)({
        issueId: issue.id,
        snapshotUrl: downloadLink.url,
        snapshotUrn: storageUrn,
        hasMarkups,
        flowId
      }));

      // Once we created the snapshot of the Issue, need to re-fetch it
      dispatch((0, _issuesCollection.fetchIssueByIdAction)({
        id: issue.id
      }));
      (0, _issueActionsTracking.trackIssueSnapshotCreate)({
        issueId: issue.id,
        trigger
      });
      await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
    } catch (e) {
      if (isAbortError(e)) {
        return;
      }
      dispatch((0, _issueSnapshots.issueSnapshotFailure)({
        issueId: issue.id
      }));
      if (handleFailureNotification) {
        handleFailureNotification();
      } else {
        showNotification({
          status: _alloyReactNotification.NOTIFICATION_STATUSES.ERROR,
          message: T.translate("thumbnailField.failureMessage")
        });
      }
    }
  }, [displayThumbnailField, throwIfAborted, sdk.Oss, sdk.IssueSnapshots, dispatch, isAbortError, showNotification, T]);
};
exports.useSetSnapshotAsAThumbnail = useSetSnapshotAsAThumbnail;
//# sourceMappingURL=useSetSnapshotAsAThumbnail.js.map